<template>
    <v-container class="dynamic-mail-storage">

        <h2>Dynamic Mail Storage</h2>

        <v-checkbox
            v-model="isDynamicMailEnabled"
            :disabled="inFlight"
            :label="isDynamicMailEnabled ? 'Enabled' : 'Enable'"
            @click="isUnchecked"
        />

        <div class="dynamic-mail-storage__input-row">
            <label for="drawer-count">Number of drawers</label>
            <ClInput
                id="drawer-count"
                v-model="models.drawers"
                :disabled="!isEditable"
                type="number"
            />
        </div>
        <div class="dynamic-mail-storage__input-row section-folders">
            <label for="folder-count">Number of folders per drawer</label>
            <ClInput
                id="folder-count"
                v-model="models.folders"
                :disabled="!isEditable"
                type="number"
            />
        </div>

        <ClButton
            aria-label="Create Dynamic Storage with selected number of drawers and folders"
            class="button-action"
            :disabled="!isEditable"
            :loading="inFlight"
            :rounded="false"
            @click="buttonHandler()"
        >
            <span>{{ hasDrawers ? 'Update' : 'Create' }}</span>
        </ClButton>

    </v-container>
</template>

<script>
// Vuex
import { mapState } from 'vuex';

export default {
    name: 'DynamicMailStorage',
    data() {
        return {
            models: {
                drawers: 0,
                folders: 0,
            },
            isDynamicMailEnabled: false,
        };
    },
    computed: {
        ...mapState( {
            dynamicMailStorage: ( state ) => state.Mail.Settings.dynamicStorage,
            inFlight: ( state ) => state.Mail.Settings.inFlight,
        } ),
        /** @returns { Boolean } */
        hasDrawers() {
            return !!this.dynamicMailStorage.drawers
                && this.isDynamicMailEnabled;
        },
        /** @returns { Boolean } */
        isEditable() {
            return this.isDynamicMailEnabled
                && !this.inFlight;
        },
    },
    mounted() {
        if ( this.dynamicMailStorage.enabled ) {
            this.isDynamicMailEnabled = true;
            this.models.drawers = this.dynamicMailStorage.drawers;
            this.models.folders = this.dynamicMailStorage.folders;
        }
    },

    methods: {
        setModels() {
            if ( this.isDynamicMailEnabled ) {
                this.models.drawers = this.dynamicMailStorage.drawers;
                this.models.folders = this.dynamicMailStorage.folders;
            } else {
                this.models.drawers = 0;
                this.models.folders = 0;
            }
        },
        async saveDynamicMailStorage() {
            await this.$store.dispatch( 'Mail/Settings/update' );
            this.setModels();
        },
        async updateMailLocators() {
            await this.$store.dispatch( 'Mail/Settings/updateMailLocators', {
                drawers: +this.models.drawers,
                folders: +this.models.folders,
            } );
        },
        async buttonHandler() {
            if ( ( parseInt( this.models.drawers, 10 ) < this.dynamicMailStorage.drawers )
                || ( parseInt( this.models.folders, 10 ) < this.dynamicMailStorage.folders ) ) {
                await this.$store.dispatch( 'dialog', {
                    title: 'Update Dynamic Mail Storage',
                    message: `Are you sure you want to change (Drawers/Folders) from
                        ( ${ this.dynamicMailStorage.drawers }/${ this.dynamicMailStorage.folders })
                        to ( ${ this.models.drawers }/${ this.models.folders })?`,
                    cancelText: 'No',
                    confirmText: 'Yes',
                    width: '500px',
                    onConfirm: () => {
                        this.updateMailLocators();
                    },
                    onCancel: () => {
                        this.setModels();
                    },
                } );
            } else {
                await this.updateMailLocators();
            }
        },
        async isUnchecked() {
            if ( !this.isDynamicMailEnabled ) {
                await this.$store.dispatch( 'dialog', {
                    title: 'Dynamic Mail Storage Disabled',
                    message: 'Are you sure you want to turn off Dynamic Mail Storage?',
                    cancelText: 'No',
                    confirmText: 'Yes',
                    width: '500px',
                    persistent: true,
                    closable: false,
                    onConfirm: () => {
                        this.$store.commit( 'Mail/Settings/SET_DYNAMIC_STORAGE_ENABLED', { boolean: false } );
                        this.saveDynamicMailStorage();
                    },
                    onCancel: () => {
                        this.$store.commit( 'Mail/Settings/SET_DYNAMIC_STORAGE_ENABLED', { boolean: true } );
                        this.isDynamicMailEnabled = true;
                    },
                } );
            } else {
                this.$store.commit( 'Mail/Settings/SET_DYNAMIC_STORAGE_ENABLED', { boolean: true } );
                await this.saveDynamicMailStorage();
            }
        },
    },
};
</script>

<style scoped lang="scss">
.dynamic-mail-storage {
    &__input-row {
        display: flex;
        flex-flow: row nowrap;
        * {
            width: 50%;
        }
    }
    .section-folders {
        margin-top: 1rem;
    }
    .button-action {
        margin-top: 1rem;
        width: 100%;
    }
}
@include mixins-above(tablet) {
    .dynamic-mail-storage {
        &__input-row {
            max-width: 40%;
        }
        .button-action {
            width: auto;
        }
    }
}
</style>
